<template>
  <div>
    <div v-if="!marks.length" class="tf-card">
      <div class="an-empty">
        <i class="fa fa-flag-checkered"></i>
        <span>За период продуктовых замеров нет</span>
      </div>
    </div>

    <template v-else>
      <div class="an-tiles">
        <div v-for="mark in marks" :key="mark.mark" class="an-tile" :title="mark.what">
          <div class="an-tile__top">
            <span class="an-tile__title">{{ mark.name }}</span>
            <span v-if="mark.verdict" class="tf-badge" :class="ratingBadge[mark.verdict]">{{ ratingText[mark.verdict] }}</span>
          </div>
          <div class="an-tile__value">{{ formatMs(mark.p75) }}</div>
          <div class="an-tile__sub">
            у 75% · быстро у {{ formatPercent(mark.goodShare) }} · {{ formatCount(mark.count) }} замеров
          </div>
          <div class="an-tile__sub">{{ mark.what }}</div>
        </div>
      </div>

      <section v-if="rows.length" class="tf-card">
        <div class="tf-card__head">
          <span class="tf-card__icon"><i class="fa fa-flag-checkered"></i></span>
          <div class="tf-card__titles">
            <h3 class="tf-card__title">По страницам</h3>
            <p class="tf-card__sub">Медиана, 75-й и 95-й перцентили</p>
          </div>
        </div>
        <div class="tf-card__body an-table-wrap">
          <table class="an-table">
            <thead>
            <tr>
              <th>Замер</th>
              <th>Страница</th>
              <th class="an-num">Замеров</th>
              <th class="an-num">Медиана</th>
              <th class="an-num">75%</th>
              <th class="an-num">95%</th>
              <th>Оценка</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in rows" :key="row.mark + row.route">
              <td>{{ row.name }}</td>
              <td>
                {{ row.routeLabel || '—' }}
                <span v-if="row.route && row.route !== row.routeLabel" class="an-cell-sub">{{ row.route }}</span>
              </td>
              <td class="an-num">{{ formatCount(row.count) }}</td>
              <td class="an-num">{{ formatMs(row.p50) }}</td>
              <td class="an-num">{{ formatMs(row.p75) }}</td>
              <td class="an-num">{{ formatMs(row.p95) }}</td>
              <td>
                <span v-if="row.verdict" class="tf-badge" :class="ratingBadge[row.verdict]">{{ ratingText[row.verdict] }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import {RATING_TEXT, RATING_BADGE, formatMs, formatPercent, formatCount} from "@/common/rumFormat";

export default {
  name: "RumProduct",
  props: {
    data: {type: Object, required: true},
  },
  data() {
    return {ratingText: RATING_TEXT, ratingBadge: RATING_BADGE}
  },
  computed: {
    marks() {
      return this.data.marks || []
    },
    rows() {
      return this.data.rows || []
    },
  },
  methods: {formatMs, formatPercent, formatCount},
}
</script>
